import { apiconst } from "../utils/app-const";
import httpService from "./httpService";

const DEFAULT_LOGIN_ERROR = 'Feil brukernavn eller passord';

export const authenticationService = {
    login,
    setRememberMe,
    setStore,
    CheckAuthentication,
    forgotPassword,
    validateResetToken,
    resetPassword
};

async function login(ChainEmail, Password, isChecked) {
    const chainEmail = ChainEmail.split(':');
    const response = await fetch(apiconst.ENDPOINT + apiconst.VERSION + apiconst.LOGIN, {
        method: "POST",
        headers: { "Content-Type": 'application/json' },
        body: JSON.stringify({ clientName: chainEmail[0], username: chainEmail[1], password: Password, RemenberMe: isChecked })
    });

    const data = await response.json();
    if (!response.ok) {
        return {
            message: data?.message || DEFAULT_LOGIN_ERROR
        };
    }
    return data;
}

async function forgotPassword(chainEmail) {
    const parts = chainEmail.split(':');
    const response = await fetch(apiconst.ENDPOINT + apiconst.VERSION + apiconst.FORGOTPASSWORD, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ clientName: parts[0], username: parts[1] })
    });
    return await response.json();
}

async function validateResetToken(clientName, employeeNo, token) {
    const url = apiconst.ENDPOINT + apiconst.VERSION + apiconst.VALIDATERESETTOKEN
        + "/" + encodeURIComponent(clientName)
        + "/" + employeeNo
        + "/" + encodeURIComponent(token);
    const response = await fetch(url, {
        method: "GET",
        headers: { "Content-Type": "application/json" }
    });
    return await response.json();
}

async function resetPassword(clientName, employeeNo, token, newPassword, confirmPassword) {
    const response = await fetch(apiconst.ENDPOINT + apiconst.VERSION + apiconst.RESETPASSWORD, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            clientName,
            employeeNo,
            token,
            newPassword,
            confirmPassword
        })
    });
    const data = await response.json();
    if (!response.ok) {
        throw new Error(data.message || "Failed to reset password");
    }
    return data;
}

async function setRememberMe(isRememberMe) {
    return await httpService.patch(apiconst.ENDPOINT + apiconst.VERSION + apiconst.REMEMBERME + "/" + isRememberMe, {});
}

async function setStore(isRememberMe, storeId) {
    return await httpService.patch(apiconst.ENDPOINT + apiconst.VERSION + apiconst.SETSTORE + "/" + isRememberMe + "/" + storeId, {});
}

async function CheckAuthentication() {
    return await httpService.get(apiconst.ENDPOINT + apiconst.VERSION + apiconst.CHECKAUTHENTICATION, {});
}